import ProxyBase from '../../../../core/proxies/ProxyBase'

class PeerAnalysisProxy extends ProxyBase {
  getOwnershipAndGroup(params) {
    return this.post('PeerAnalysis/OwnershipAndGroup', params)
  }

  getFinancialStatements(params) {
    return this.post('PeerAnalysis/FinancialStatements', params)
  }

  getScore(params) {
    return this.post('PeerAnalysis/Score', params)
  }

  getFinancialAnalysis(params) {
    return this.post('PeerAnalysis/FinancialAnalysis', params)
  }

  getYearReports(params) {
    return this.get('Setting/YearReports', params)
  }

  getSavedPortfolio(params) {
    return this.get('Library/SavedPortfolio', params)
  }

  getRecommendationPortfolio(params) {
    return this.get('PeerAnalysis/Recommendation/Portfolio', params)
  }

  getRecommendationRevenue(params) {
    return this.get('PeerAnalysis/Recommendation/Revenue', params)
  }

  getRecommendationYearsOfOperation(params) {
    return this.get('PeerAnalysis/Recommendation/YearsOfOperation', params)
  }

  postMoveOrCopyCompany(params) {
    return this.post('Library/MoveOrCopyCompany', params)
  }
}

export default new PeerAnalysisProxy()
